import { useTranslation } from 'react-i18next';

const icons = ['ri-eye-line', 'ri-compass-3-line', 'ri-scales-3-line', 'ri-lock-line'];

function renderParagraphs(text: string, className: string) {
  return text.split(/\n{2,}/).filter((part) => part.length > 0).map((part, index) => (
    <p key={index} className={className}>
      {part}
    </p>
  ));
}

export default function Qualities() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('butlerJob.qualities.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('butlerJob.qualities.title')}
          </h2>
          <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
            {t('butlerJob.qualities.titleEn')}
          </p>
          <div className="gold-line mx-auto mb-6"></div>
          {renderParagraphs(
            String(t('butlerJob.qualities.lead')),
            'text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto',
          )}
        </div>

        <div className="mb-14 overflow-hidden rounded-sm">
          <img
            src="/images/generated/skill-observation-2026.jpg"
            alt={t('butlerJob.qualities.imgAlt')}
            className="w-full h-[280px] md:h-[420px] object-cover"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {icons.map((icon, idx) => (
            <div
              key={idx}
              className="card-glow bg-background-100/60 border border-background-200/60 p-6 md:p-8 flex items-start gap-5 cursor-default"
            >
              <div className="w-12 h-12 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center flex-shrink-0">
                <i className={`${icon} text-accent-500 text-xl`}></i>
              </div>
              <div>
                <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-2.5">
                  {t(`butlerJob.qualities.${idx}.title`)}
                </h3>
                {renderParagraphs(
                  String(t(`butlerJob.qualities.${idx}.desc`)),
                  'text-[16px] text-foreground-500 tracking-[0.04em] leading-[1.85]',
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
